import React from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import { StyledSocialLink } from "./styles";

const SharePhotoToSocialMedia = ({ children, photo, platform }) => {
    const getShareUrl = () => {
        const photoPermalink = `https://${location.host}/photo/${photo.slugWithId}/`;

        let shareUrl = "";
        let shareUrlQueryParams = "";

        const shareText = `Love this photo ${
            photo.creator.name ? `by ${photo.creator.name} ` : ``
        }from @NounProject.`;

        if (platform === "Twitter") {
            shareUrl = "https://twitter.com/intent/tweet";

            shareUrlQueryParams = {
                text: shareText,
                url: photoPermalink
            };
        } else if (platform === "Facebook") {
            shareUrl = "https://www.facebook.com/sharer/sharer.php";

            shareUrlQueryParams = {
                u: photoPermalink
            };
        }

        const shareUrlQueryParamsStringified = queryString.stringify(
            shareUrlQueryParams
        );

        return `${shareUrl}/?${shareUrlQueryParamsStringified}`;
    };

    const openWindowToShare = ({ shareUrl }) => {
        const width = 575;
        const height = 400;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        const windowOptions = `status=1,width=${width},height=${height},left=${left},top=${top}`;

        return window.open(shareUrl, "", windowOptions);
    };

    const handleClick = e => {
        e.preventDefault();

        const shareUrl = getShareUrl();
        openWindowToShare({ shareUrl });
    };

    return (
        <StyledSocialLink href="" onClick={handleClick}>
            {children}
        </StyledSocialLink>
    );
};

SharePhotoToSocialMedia.propTypes = {
    photo: PropTypes.object.isRequired,
    platform: PropTypes.oneOf(["Twitter", "Facebook"]).isRequired
};

export default SharePhotoToSocialMedia;
